import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";

import {setLookContextMenu} from "../../../actions/lookFunctions";

import {getCurrentLayout} from "../../appLayout";
import {checkIfLookFeaturesReceived} from "../../../api/look-api";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import goToMaterialPage from "../../common/goToMaterialPage";


const needToRequestFeatureGroupsOnClick = ["vanity_washstand", "vanity_console", "shower_arm", "shower_head"];

const ContextMenuQKBButtons = (props) => {

  const {setLookContextMenu, buttons, handleContextMenuClick, activeQuoteIndex,
    renderGreenLayerByZindex} = props;

  const layout = getCurrentLayout();

  // const isShower = isBathroom && (CONTEXT_MENU_SHOWER_ALL.includes(partId) || CONTEXT_MENU_SHOWER_OTHER.includes(partId));

  const contextButtonClick = async (clickedButton) => {
    // console.log("currentPartId", currentPartId);

    const {partId, isWizard, wizardId} = clickedButton;

    setLookContextMenu({
      opened: false,
      layerPosition: "",
      clickedOnItem: partId,
    });

    let openPartId = partId;
    let clickedFeature = null;

    if (isWizard) {
      goToMaterialPage("visualizer", false, null, "",
        {wizardItemId: wizardId, quoteIndex: activeQuoteIndex});
      return false
    }

    const featureGroup = layout.getFeatureGroupByPartId(openPartId);
    if (featureGroup && !featureGroup.allFeaturesReceived && needToRequestFeatureGroupsOnClick.includes(openPartId)) {
      loaderEnable();
      await checkIfLookFeaturesReceived(featureGroup);
      loaderDisable();
    }

    // console.log("zoomedFeature", clickedFeature);
    handleContextMenuClick(clickedFeature, openPartId);
  };

  const onMouseOver = (button) => {
    if (renderGreenLayerByZindex) {
      const featureGroup = layout.getFeatureGroupByPartId(button.partId);
      if (featureGroup && featureGroup.activeFeature && featureGroup.activeFeature.layer) {
        renderGreenLayerByZindex(featureGroup.activeFeature.layer.zIndex, button.partId);
      }
    }
  }

  let contextMenuStyles = buttons.length === 14 ? {maxWidth:"210px"} : null;

  console.log("buttons", buttons);

  return (
    <div style={contextMenuStyles}>
      <div className="contextmenu-buttons">
        {buttons.map(button => {
          return (
            <button key={button.partId}
                    onMouseOver={() => onMouseOver(button)}
                    onClick={() => contextButtonClick(button)}
                    className={"contextmenu-buttons__button contextmenu-buttons__button--"
                      + (button.partId && (button.partId.includes("wizard") ? "wizard" : button.partId))}>
              {button.partId === "Configure Layout" ? (
                <div className="sprocket-container">
                  <div className="sprocket small spin reverse"/>
                  <div className="sprocket large spin"/>
                </div>
              ) : null}
              <span className="contextmenu-buttons__button-text">
                <FormattedMessage id={button.translateId}/>
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
};

ContextMenuQKBButtons.propTypes = {
  handleContextMenuClick: PropTypes.func,
  setButtons: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {contextMenu} = store.lookState;
  const {isMobile} = store.serverState;
  const {wizardList} = store.wizardState;
  const fabricatorData = store.fabricatorState;
  const {activeQuoteIndex} = store.quotesState;

  return {
    contextMenu,
    isMobile,
    wizardList,
    fabricatorData,
    activeQuoteIndex,
  };
};

const mapDispatchToProps = {
  setLookContextMenu,
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ContextMenuQKBButtons)
  )
)
